import { SxProps } from '@mui/system';
import { Theme } from '@mui/material';

export function makeSxProps<ClassKey extends string = string,>(
  styles: Record<ClassKey, SxProps<Theme>>,
): Record<ClassKey, SxProps<Theme>>  {
  return styles;
}
